var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('info-box',{attrs:{"description":_vm.description}}),_vm._v(" "),_c('header-title',{attrs:{"title_img_src":_vm.title_img}}),_vm._v(" "),_c('nav-bar'),_vm._v(" "),_c('br'),_vm._v(" "),_c('slider')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53395fd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = tZZy
// module chunks = 1